module.exports = __webpack_public_path__ + "media/src/assets/Images/Trash-a365afb6aa74a0d071af58b1c1dda279.svg";